// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"24":"c6a02d5268e9fd01eadf","238":"7d5969539c447da95187"}[chunkId] + ".js";
};